const STORAGE_KEY = 'pharmaid_table_column_widths'

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

function writeAll(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  } catch {
    // ignore quota / private mode errors
  }
}

function groupKey(labelGroup) {
  return labelGroup == null || labelGroup === '' ? 'default' : String(labelGroup)
}

/** 读取某板块已保存的列宽 map：{ [columnKey]: number } */
export function getStoredColumnWidths(labelGroup) {
  const all = readAll()
  const group = all[groupKey(labelGroup)]
  if (!group || typeof group !== 'object') return {}
  const result = {}
  Object.keys(group).forEach((key) => {
    const n = Number(group[key])
    if (Number.isFinite(n) && n > 0) result[key] = n
  })
  return result
}

/** 合并写入某板块列宽（只更新传入的 key） */
export function saveStoredColumnWidths(labelGroup, widths) {
  if (!widths || typeof widths !== 'object') return
  const all = readAll()
  const key = groupKey(labelGroup)
  all[key] = {
    ...(all[key] && typeof all[key] === 'object' ? all[key] : {}),
    ...widths,
  }
  writeAll(all)
}

/** 覆盖写入某板块全部列宽 */
export function setStoredColumnWidths(labelGroup, widths) {
  const all = readAll()
  all[groupKey(labelGroup)] = widths && typeof widths === 'object' ? { ...widths } : {}
  writeAll(all)
}
